<div class="modal-content">
  <div class="header">
    <h2 class="title">Terms and Conditions</h2>
    <div class="close-btn" (click)="closeTnC()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="main-modal-content loan-continue">
    <div class="new-card tnc">
      <ul>
        <li *ngFor="let p of tncs?.body" [innerHTML]="p"></li>
      </ul>
    </div>
  </div>
</div>